import { desktopFirstMediaQuery } from '@inflearn/ds-react-next';

export const MobileOnlyBreak = () => {
  return (
    <br
      css={{
        display: 'none',

        [desktopFirstMediaQuery.mobile]: {
          display: 'block',
        },
      }}
    />
  );
};
